import { Component, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { Chat } from 'src/app/services/chat.service';
import { selectCurrentChat, selectIsLoading } from 'src/app/store/selectors/chats.selectors';
import { selectIsDisconnectedFromSocket } from 'src/app/store/selectors/socket.selectors';

export interface ChatInputs {
  message: string;
  attachment: File;
}

@Component({
  selector: 'mvp-chat-inputs',
  templateUrl: './chat-inputs.component.html',
})
export class ChatInputsComponent implements OnInit, OnDestroy {

  @Output() onSend = new EventEmitter<ChatInputs>();
  attachment: File;
  message: string;
  isConnectedToSocket$: Observable<boolean>;
  isDisconnectedFromSocket$: Observable<boolean>;
  isLoading$: Observable<boolean>;
  currentChat$: Observable<Chat>;
  private chatUuidSubscription?: Subscription;

  constructor(
    private store: Store,
  ) {
    this.isDisconnectedFromSocket$ = this.store.select(selectIsDisconnectedFromSocket);
    this.currentChat$ = this.store.select(selectCurrentChat);
    this.isLoading$ = this.store.select(selectIsLoading);
  }

  ngOnInit() {
    this.chatUuidSubscription = this.currentChat$
      .pipe(
        map((chat: Chat) => chat?.uuid || null),
        distinctUntilChanged(),
      )
      .subscribe(() => {
        this.reset();
      });
  }

  ngOnDestroy() {
    this.chatUuidSubscription?.unsubscribe();
  }

  send() {
    if (!this.message || this.message.length < 3) {
      return;
    }

    this.onSend.emit({
      message: this.message,
      attachment: this.attachment,
    });

    this.reset();
  }

  typing(isTyping: boolean) {
    //
  }

  handleFile(event: any) {
    const file: File = event.target.files[0];
    this.attachment = file;
  }

  reset() {
    this.message = null;
    this.attachment = null;
  }

}
